import { useTranslation } from 'react-i18next';
import { Text, TextAlignment, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 5rem;
`;

const StyledTitle = styled.div`
  margin: 2rem;
`;
export const ErrorSite = (): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <StyledTitle>
        <Text bold appearance={TokenTextAppearance.headline300} data-testid="error-title">
          {t(`giveaway.error.title`)}
        </Text>
      </StyledTitle>
      <Text
        textAlign={TextAlignment.center}
        appearance={TokenTextAppearance.headline100}
        data-testid="error-message"
      >
        {t(`giveaway.error.message`)}
      </Text>
    </StyledContainer>
  );
};
